import {
  Controller,
  Control,
  FieldValues,
  DeepMap,
  FieldError,
  RegisterOptions,
} from 'react-hook-form';
import TextField from '@mui/material/TextField';
import { Tooltip } from '@mui/material';

interface TextInputProps {
  label: string;
  name: string;
  control: Control<any>;
  required?: boolean;
  errors?: DeepMap<FieldValues, FieldError>;
  rules?: Exclude<
    RegisterOptions,
    'valueAsNumber' | 'valueAsDate' | 'setValueAs'
  >;
  type?: string;
  inputProps?: any;
  defaultValue?: any;
  className?: string;
  multiline?: boolean;
  disabled?: boolean;
  tooltip?: string;
  children?: React.ReactNode;
}

export default function TextInput({
  label,
  name,
  control,
  required = false,
  errors,
  rules = undefined,
  type = 'text',
  inputProps = undefined,
  defaultValue = undefined,
  className = undefined,
  multiline = false,
  disabled = false,
  tooltip = '',
  children,
}: TextInputProps) {
  const handleChange = (onChange: (event: any) => void) => {
    return (
      event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    ) => {
      if (type === 'email') {
        onChange(event.target.value.toLowerCase());
      } else {
        onChange(event);
      }
    };
  };

  return (
    <Controller
      name={name as any}
      control={control}
      defaultValue={defaultValue || ''}
      rules={rules}
      render={({ field }) => (
        <Tooltip title={tooltip || ''} placement="bottom">
          <TextField
            className={className}
            {...field}
            onChange={handleChange(field.onChange)}
            label={label}
            multiline={multiline}
            required={required}
            variant="outlined"
            helperText={errors ? errors[name]?.message : undefined}
            type={type}
            inputProps={inputProps}
            error={errors ? !!errors[name] : false}
            disabled={disabled}>
            {children}
          </TextField>
        </Tooltip>
      )}
    />
  );
}
